/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 26/7/2021
 * @Example
 */

export const types = {
    W06F0008_GET_CBO_EMPLOYEE: 'W06F0008_GET_CBO_EMPLOYEE',
    W06F0008_GET_CBO_SUBCONTRACT_TYPE: 'W06F0008_GET_CBO_SUBCONTRACT_TYPE',
    W06F0008_GET_POPUP: 'W06F0008_GET_POPUP',
    W06F0008_LOAD_FORM: 'W06F0008_LOAD_FORM',
    W06F0008_CHECK_EDIT: 'W06F0008_CHECK_EDIT',
    W06F0008_DELETE: 'W06F0008_DELETE',
    W06F0008_APPROVAL: 'W06F0008_APPROVAL',
    W06F0008_GET_CBO_APPROVE: 'W06F0008_GET_CBO_APPROVE'
}


export function getCboEmployees(params, cb) {
    return {
        type: types.W06F0008_GET_CBO_EMPLOYEE,
        params,
        cb
    }
}

export function getCbSubContractType(params, cb) {
    return {
        type: types.W06F0008_GET_CBO_SUBCONTRACT_TYPE,
        params,
        cb
    }
}

export function getPopupContract(params, cb) {
    return {
        type: types.W06F0008_GET_POPUP,
        params,
        cb
    }
}

export function loadForm(params, cb) {
    return {
        type: types.W06F0008_LOAD_FORM,
        params,
        cb
    }
}

export function onCheckEdit(params, cb) {
    return {
        type: types.W06F0008_CHECK_EDIT,
        params,
        cb
    }
}

export function onDelete(params, cb) {
    return {
        type: types.W06F0008_DELETE,
        params,
        cb
    }
}

export function onApproval(params, cb) {
    return {
        type: types.W06F0008_APPROVAL,
        params,
        cb
    }
}

export function getCbApprove(params, cb) {
    return {
        type: types.W06F0008_GET_CBO_APPROVE,
        params,
        cb
    }
}
